import { Category } from '../model/types/CategorySchema';

export const isUncategorizedCatalogCategory = (
    categoryOrTitle: Pick<Category, 'title'> | string,
): boolean => {
    const title =
        typeof categoryOrTitle === 'string'
            ? categoryOrTitle
            : categoryOrTitle.title;

    return title.trim().toLowerCase() === 'uncategorized';
};
